import { useEffect, useLayoutEffect as useLayoutEffectImpl } from "react"

export const useLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffectImpl : useEffect
